import { LocationViewModel } from "src/app/view-models/location.view-model";
import { StoredLocation } from "../models/stored-location";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between Location view model and database StoredLocation.
 */
export class LocationMapper implements IStoredMapper<LocationViewModel, StoredLocation> {
	/**
	 * Maps a Location to a StoredLocation.
	 * @param location The location data to convert.
	 * @returns A StoredLocation object.
	 */
	public ToStored(location: LocationViewModel): StoredLocation {
		return {
			AddressName: location.AddressName,
			Address1: location.Address1,
			Address2: location.Address2,
			City: location.City,
			Region: location.Region,
			PostalCode: location.PostalCode,
			AirportCode: location.AirportCode,
			ContactName: location.ContactName,
			PhoneNumber: location.PhoneNumber,
			Instructions: location.Instructions
		};
	}

	/**
	 * Maps a StoredLocation to a Location.
	 * @param storedLocation The stored location data to convert.
	 * @returns A Location object.
	 */
	public FromStored(storedLocation: StoredLocation): LocationViewModel {
		return {
			AddressName: storedLocation.AddressName,
			Address1: storedLocation.Address1,
			Address2: storedLocation.Address2,
			City: storedLocation.City,
			Region: storedLocation.Region,
			PostalCode: storedLocation.PostalCode,
			AirportCode: storedLocation.AirportCode,
			ContactName: storedLocation.ContactName,
			PhoneNumber: storedLocation.PhoneNumber,
			Instructions: storedLocation.Instructions
		};
	}
}